__turbopack_context__.v({
  "grid": "tools-page-module__2xmSHW__grid",
  "lead": "tools-page-module__2xmSHW__lead",
  "page": "tools-page-module__2xmSHW__page",
  "title": "tools-page-module__2xmSHW__title",
});
